import { graphql } from "~/gql";

export const TECHNOLOGY_CHARGE_FRAGMENT = graphql(/* GraphQL */ `
  fragment TechnologyChargeParts on TechnologyCharge {
    id
    description
    currencyId
    fixedAmount
    baseAmount
    percentage
    type
    unitCost
    units
    order
    matterId
    notes
    libraryTechnologyId
    libraryTechnology {
      ...LibraryTechnologyParts
    }
    technologyUnitId
    technologyUnit {
      ...TechnologyUnitParts
    }
    createdAt
    updatedAt
  }
`);
